












































































import _ from 'lodash';
import { Component, Vue, Inject } from 'vue-property-decorator';
import Footer from '../components/Footer.vue';
import iView from 'iview';
import AbpBase from '../lib/abpbase';
import Util from '../lib/util';
import AuthService from '../services/auth';
import auth from '../services/auth';
import AppConsts from '@/lib/appconst';
@Component({
    components: { Footer },
})
export default class Login extends AbpBase {
    loginModel = {
        userNameOrEmailAddress: '',
        password: '',
        rememberMe: false,
    };
    showChangeTenant: boolean = false;
    isLoading: boolean = true;

    async checkTenant() {
        await this.$store
            .dispatch({
                type: 'account/InitLoginInfo',
                data: {
                    userNameOrEmail: this.loginModel.userNameOrEmailAddress,
                },
            })
            .then((res) => {
                let tenant = res;
                switch (tenant.state) {
                    case "Available":
                        Util.abp.multiTenancy.setTenantIdCookie(
                            tenant.tenantId
                        );
                        this._login();
                        return;
                    case "InActive":
                        this.$Message.destroy();
                        this.$Modal.error({
                            title: this.L('Error'),
                            content: this.L('TenantIsNotActive'),
                        });
                        break;
                    default:
                        this._login();
                        break;
                }
            })
            .catch(() => {
                this.$Message.destroy();
            });
    }

    async checkTenantForOauth2(user) {
        await this.$store
            .dispatch({
                type: 'account/InitLoginInfo',
                data: {
                    userNameOrEmail: user.profile.name,
                    createIfEmpty: true,
                    provider: 'IS4',
                    providerKey: user.profile.sub,
                    token: user.access_token,
                },
            })
            .then((res) => {
                let tenant = res;
                // var tokenExpireDate = new Date(
                //   new Date().getTime() + 1000 * res.expireInSeconds
                // );
                if (!_.isEmpty(res.encryptToken)) {
                    Util.abp.utils.setCookieValue(
                        AppConsts.authorization.encrptedAuthTokenName,
                        res.encryptToken,
                        null,
                        Util.abp.appPath
                    );
                }

                switch (tenant.state) {
                    case "Available":
                        Util.abp.multiTenancy.setTenantIdCookie(
                            tenant.tenantId
                        );
                        Util.abp.auth.setToken(user.access_token, undefined);
                        location.reload();
                        return;
                    case "InActive":
                        this.$Message.destroy();
                        this.$Modal.error({
                            title: this.L('Error'),
                            content: this.L('TenantIsNotActive'),
                        });
                        break;
                    case "HostUser":
                        Util.abp.multiTenancy.setTenantIdCookie();
                        Util.abp.auth.setToken(user.access_token, undefined);
                        location.reload();
                        break;
                    default:
                        this.$router.push({
                            name: 'error-403',
                            replace: true,
                        });
                        break;
                }
            })
            .catch((err) => {
                console.log(err);
                // this.$Message.destroy();
                // Util.abp.multiTenancy.setTenantIdCookie(null);
                // Util.abp.auth.setToken(user.access_token, undefined);
                // location.reload();
            });
    }

    async _login() {
        await this.$store
            .dispatch({
                type: 'app/login',
                data: this.loginModel,
            })
            .then((res) => {
                let requireChangePassword = res;
                if (requireChangePassword) {
                    this.$store.commit('app/requireToChangePassword', true);
                }
                sessionStorage.setItem(
                    'rememberMe',
                    this.loginModel.rememberMe ? '1' : '0'
                );
                location.reload();
            })
            .catch(() => {
                this.$Message.destroy();
            });
    }

    async login() {
        AuthService.login();
    }
    get tenant() {
        return this.$store.state.session.tenant;
    }
    rules = {
        userNameOrEmailAddress: [
            {
                required: true,
                message: this.L('UserNameRequired'),
                trigger: 'blur',
            },
        ],
        password: [
            {
                required: true,
                message: this.L('PasswordRequired'),
                trigger: 'blur',
            },
        ],
    };
    created() {}
    mounted() {
        window.addEventListener('keyup', (event) => {
            if (event.keyCode === 13) {
                this.login();
            }
        });

        const isAuth = sessionStorage.getItem('isAuth');
        if (isAuth !== 'true') {
            const isSilentAuth = sessionStorage.getItem('isSilentAuth');
            if (isSilentAuth == 'true') {
                sessionStorage.setItem('isSilentAuth', 'false');

                AuthService.login()
                    .then(() => {
                        this.isLoading = false;
                    })
                    .catch(() => {
                        this.isLoading = false;
                    });
            } else {
                this.isLoading = false;
            }

            return;
        }
        AuthService.getUser().then((user) => {
            if (user) {
                if (
                    _.isEmpty(Util.abp.multiTenancy.getTenantIdCookie()) &&
                    _.isEmpty(Util.abp.auth.getToken())
                ) {
                    this.checkTenantForOauth2(user);
                } else {
                    this.isLoading = false;
                    auth.silentLogout();
                    Util.abp.auth.setToken();
                }
            } else {
                this.isLoading = false;
            }
        });
    }
}
